<div class="section-divider d-none d-md-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🏠 KNX</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<!-- Sub-tabs (same pill look as the mobile tab strip): equal segments with the icon on top on phones -->
<div class="mb-2">
  <div class="knx-subtabs nav-pills-mobile" role="tablist">
    <button *ngFor="let s of subTabs; trackBy: trackSubTab"
            type="button" role="tab"
            class="nav-tab-btn py-1 px-1 px-md-3 rounded-3 border-0 small fw-semibold"
            [class.active]="subTab === s.key"
            [attr.aria-selected]="subTab === s.key"
            [title]="s.label | translate"
            (click)="setSubTab(s.key)"><span class="knx-subtab-icon">{{ s.icon }}</span><span class="knx-subtab-label d-md-none">{{ (s.short ?? s.label) | translate }}</span><span class="knx-subtab-label d-none d-md-inline">{{ s.label | translate }}</span></button>
  </div>
</div>

<ng-container [ngSwitch]="subTab">

  <!-- ═══ Lichter / Steckdosen / Rollläden (read-only) ═══ -->
  <app-knx-switches *ngSwitchCase="'lights'"
    kind="light"
    [devices]="knxDevices?.lights ?? null"
    [updatedAt]="knxDevices?.updatedAt ?? knxDevicesUpdatedAt"
    [flash]="knxDevicesFlash"
    [liveDotOn]="liveDotOn"
    [nowTick]="nowTick"
    [darkMode]="darkMode">
  </app-knx-switches>

  <app-knx-switches *ngSwitchCase="'sockets'"
    kind="socket"
    [devices]="knxDevices?.sockets ?? null"
    [updatedAt]="knxDevices?.updatedAt ?? knxDevicesUpdatedAt"
    [flash]="knxDevicesFlash"
    [liveDotOn]="liveDotOn"
    [nowTick]="nowTick"
    [darkMode]="darkMode">
  </app-knx-switches>

  <app-knx-blinds *ngSwitchCase="'blinds'"
    [devices]="knxDevices?.blinds ?? null"
    [updatedAt]="knxDevices?.updatedAt ?? knxDevicesUpdatedAt"
    [flash]="knxDevicesFlash"
    [liveDotOn]="liveDotOn"
    [nowTick]="nowTick"
    [darkMode]="darkMode">
  </app-knx-blinds>

  <!-- ═══ Wetter (weather station, passively overheard) ═══ -->
  <app-knx-weather *ngSwitchCase="'weather'"
    [weather]="knxWeather"
    [liveDotOn]="liveDotOn"
    [nowTick]="nowTick"
    [darkMode]="darkMode">
  </app-knx-weather>

</ng-container>
